import React from 'react';

import { ResponderNamesWrapper } from '@atlassian/eoc-responder-names';
import { ErrorBoundary } from '@atlassian/jira-error-boundary';
import { FieldLoader, FieldContainer } from '@atlassian/jira-issue-create-commons';
import Placeholder from '@atlassian/jira-placeholder';

import { AsyncLinkedAlertsField } from './async';
import type { Props } from './ui';

export const LinkedAlertsField = (props: Props) => (
	<ErrorBoundary id="issue.fields.linked-alerts" packageName="AsyncLinkedAlertsField">
		<ResponderNamesWrapper>
			<FieldContainer data-testid="issue-field-linked-alerts.field-container" width="100%">
				<Placeholder name="linked-alerts-field" fallback={<FieldLoader />}>
					<AsyncLinkedAlertsField {...props} />
				</Placeholder>
			</FieldContainer>
		</ResponderNamesWrapper>
	</ErrorBoundary>
);
